module.exports = __webpack_public_path__ + "img/empreendimento-logo-3.b8738096.png";